import { render } from "./UpsertEvent.vue?vue&type=template&id=e918dacc&scoped=true"
import script from "./UpsertEvent.vue?vue&type=script&lang=js"
export * from "./UpsertEvent.vue?vue&type=script&lang=js"

import "./UpsertEvent.vue?vue&type=style&index=0&id=e918dacc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e918dacc"]])

export default __exports__